import { render } from "./booking1.vue?vue&type=template&id=c692328c"
import script from "./booking1.vue?vue&type=script&lang=js"
export * from "./booking1.vue?vue&type=script&lang=js"
script.render = render

export default script